import styled from '@emotion/styled';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DefaultAvatar from 'common/images/default-avatar.png';

const UserImageWrapper = styled.div`
    height: 48px;
    width: 48px;
    min-height: 48px;
    min-width: 48px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid ${(props) => props.theme.colors.gray};
`;

type ChatListUserProps = {
  id?: string | number;
  name?: string;
  text?: string;
  image?: string;
};

export default function ChatListUser({ id, name, text, image }: ChatListUserProps) {
  const { chatId } = useParams() || null;
  const navigate = useNavigate();
  const openChat = () => {
    navigate(`${id || 0}`, { replace: true });
  };
  console.log(chatId + ' ' + id);
  return (
    <div onClick={openChat} className={`chat-list-user-wrapper${chatId == id ? ' active' : ''}`}>
        <UserImageWrapper>
            <img width={48} src={image || DefaultAvatar} alt="user" />
        </UserImageWrapper>
        <div className='chat-list-user-text-wrapper'>
            <span className="chat-list-user-name">{name || 'Blank'}</span>
            <span className="chat-list-user-text">{text || ''}</span>
        </div>
    </div>
  );
}